var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/clientManagement"
              }
            },
            [_vm._v("Client Management")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("\n        Create Dummy Account\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c("div", { staticClass: "requireRmarks" }, [
            _vm._v("\n        *Required Fields\n      ")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formAccount",
              attrs: {
                "label-width": "50%",
                "label-position": "left",
                model: _vm.formAccount,
                rules: _vm.formAccountRules
              }
            },
            [
              _c("el-row", [_c("h4", [_vm._v("Personal Information")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Dummy Account Type",
                            prop: "userType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { "popper-append-to-body": false },
                              model: {
                                value: _vm.formAccount.userType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "userType", $$v)
                                },
                                expression: "formAccount.userType"
                              }
                            },
                            _vm._l(_vm.userTypeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Dummy Account Remarks",
                            prop: "userTypeRemarks"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: _vm.formAccount.userTypeRemarks,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formAccount,
                                  "userTypeRemarks",
                                  $$v
                                )
                              },
                              expression: "formAccount.userTypeRemarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Username", prop: "userName" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formAccount.userName,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "userName", $$v)
                              },
                              expression: "formAccount.userName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Password", prop: "password" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formAccount.password,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "password", $$v)
                              },
                              expression: "formAccount.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Last Name", prop: "lastName" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.formAccount.lastName,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "lastName", $$v)
                              },
                              expression: "formAccount.lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "First Name", prop: "firstName" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.formAccount.firstName,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "firstName", $$v)
                              },
                              expression: "formAccount.firstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Middle Name", prop: "middleName" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.formAccount.middleName,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "middleName", $$v)
                              },
                              expression: "formAccount.middleName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Date Of Birth", prop: "dob" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              format: "yyyy/MM/dd",
                              placeholder: "Date of Birth"
                            },
                            model: {
                              value: _vm.formAccount.dob,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "dob", $$v)
                              },
                              expression: "formAccount.dob"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email Address", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.formAccount.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formAccount, "email", $$v)
                              },
                              expression: "formAccount.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Sales Information")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Sales Office", prop: "salesOffice" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: _vm.$store.state.userLevel >= 2
                              },
                              on: { change: _vm.changeSalesOffice },
                              model: {
                                value: _vm.formAccount.salesOffice,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "salesOffice", $$v)
                                },
                                expression: "formAccount.salesOffice"
                              }
                            },
                            _vm._l(_vm.salesOfficeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Region", prop: "region" } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.formAccount.region,
                                callback: function($$v) {
                                  _vm.$set(_vm.formAccount, "region", $$v)
                                },
                                expression: "formAccount.region"
                              }
                            },
                            _vm._l(_vm.regionList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Sales Representative Name",
                            prop: "representativeName"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.formAccount.representativeName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formAccount,
                                  "representativeName",
                                  $$v
                                )
                              },
                              expression: "formAccount.representativeName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "reset",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.handleCancel }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleCreate }
                },
                [_vm._v("Create")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.confirmInfoDialog,
            width: "400px",
            "close-on-click-modal": false,
            "show-close": false,
            "custom-class": "confirmInfo"
          },
          on: {
            "update:visible": function($event) {
              _vm.confirmInfoDialog = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              staticStyle: {
                margin: "0 0 15px",
                "font-size": "20px",
                "text-align": "center",
                "font-weight": "bold"
              }
            },
            [_vm._v("Dummy account is created!")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "16px",
                width: "75%",
                margin: "0 auto",
                "line-height": "1.5"
              }
            },
            [
              _vm._v(
                "Please copy and send the following Information to the user:"
              )
            ]
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticStyle: { "text-align": "left" }, attrs: { span: 12 } },
                [
                  _c("span", { staticStyle: { color: "#003448" } }, [
                    _vm._v("Client ID")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { span: 12 } },
                [
                  _c("span", { staticStyle: { color: "#003448" } }, [
                    _vm._v(_vm._s(_vm.userInfo.clientID))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticStyle: { "text-align": "left" }, attrs: { span: 12 } },
                [
                  _c("span", { staticStyle: { color: "#003448" } }, [
                    _vm._v("Username")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { span: 12 } },
                [
                  _c("span", { staticStyle: { color: "#003448" } }, [
                    _vm._v(_vm._s(_vm.userInfo.username))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticStyle: { "text-align": "left" }, attrs: { span: 12 } },
                [
                  _c("span", { staticStyle: { color: "#003448" } }, [
                    _vm._v("Password")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { span: 12 } },
                [
                  _c("span", { staticStyle: { color: "#003448" } }, [
                    _vm._v(_vm._s(_vm.formAccount.password))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("Close")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleCopy } },
                [_vm._v("Copy")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.copyTxt,
            expression: "copyTxt"
          }
        ],
        staticStyle: { position: "absolute", left: "-9999px" },
        attrs: { name: "copyTxt", id: "copyTxt" },
        domProps: { value: _vm.copyTxt },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.copyTxt = $event.target.value
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-710a845a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710a845a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appUser/createUser.vue
// module id = null
// module chunks = 